import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { useLogout } from '../hooks/useLogout';

const Navbar = () => {
	const { logout } = useLogout();
	const { user } = useContext(AuthContext);

	const handleClick = () => {
		logout();
	};

	return (
		<header>
			<div className="container">
				<Link to="/">
					<img
						src={require('./logo.png')}
						width={323}
						height={192}
						alt="logo"
					/>
				</Link>
				<ul>
					<li className="button-container">
						{user && (
							<div>
								<span>{user.email}</span>
								<button onClick={handleClick} className="logout">
									Çıkış Yap
								</button>
								{user.hasSettingsAccess ? (
									<a href="/ayarlar" className="create" id="logo">
										Ayarlar
									</a>
								) : (
									''
								)}
								<a href="/olustur" className="create" id="logo">
									Oluştur
								</a>
							</div>
						)}
						{!user && (
							<div>
								<a href="/login" className="create" id="login">
									Giriş Yap
								</a>
							</div>
						)}
					</li>
				</ul>
			</div>
		</header>
	);
};

export default Navbar;
